//noScroll
class MenuEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const trigger = document.querySelector(".js-hum");
    const menu = document.querySelector(".menu");
    const entryBtn = document.querySelector(".entry-btn");
    const overlay = document.querySelector(".menu-overlay");
    const body = document.querySelector("body");

    trigger.addEventListener('click',() => {
      trigger.classList.toggle('is-active')
      menu.classList.toggle('is-active')
      entryBtn.classList.toggle('is-hidden')
      overlay.classList.toggle('is-active')
      body.classList.toggle('no_scroll')
    });

    overlay.addEventListener('click',() => {
      trigger.classList.remove('is-active')
      menu.classList.remove('is-active')
      entryBtn.classList.remove('is-hidden')
      overlay.classList.remove('is-active')
      body.classList.remove('no_scroll')
    });
  }
}
